module.exports = __webpack_public_path__ + "img/logoFondoBlanco.d27394db.png";